import { useEffect, useState } from 'react'

import { builder } from 'app/utils/builder'

export type Props = Record<string, never>

export default function GcJackpotWinnersTable() {
  const [winners, setWinners] = useState([])
  const abortController = new AbortController()

  async function fetchBanners() {
    try {
      const jackpotWinners = await builder.getAll('gc-jackpot-winners', {
        options: {
          signal: abortController.signal,
        },
      })
      setWinners(jackpotWinners)
    } catch (error) {
      if (!abortController.signal.aborted) {
        console.log('fetch jackpot winners Error', error)
        setWinners([])
      }
    }
  }

  useEffect(() => {
    fetchBanners()

    return () => {
      abortController.abort()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <table>
      <thead>
        <tr>
          <th style={{ textAlign: 'left' }}>
            <strong>Name</strong>
          </th>
          <th style={{ textAlign: 'left' }}>
            <strong>Date</strong>
          </th>
          <th style={{ textAlign: 'left' }}>
            <strong>Jackpot</strong>
          </th>
        </tr>
      </thead>
      <tbody>
        {winners
          .sort((a, b) => a.data.index - b.data.index)
          .map((item) => {
            return (
              <tr key={item.data.index}>
                <td style={{ textAlign: 'left' }}>{item.data.name}</td>
                <td style={{ textAlign: 'left' }}>{item.data.date}</td>
                <td style={{ textAlign: 'left' }}>{item.data.jackpot}</td>
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}
